import React, { FC, useEffect } from 'react'
import i18n from 'i18next'
import { IMenuItemProps } from '../Bill'
import payMobx from '@mobx/pay/pay.mobx'
import { stripeConfigG } from '@ctrls/third'
import { observer } from 'mobx-react'

const MenuItem: FC<IMenuItemProps> = ({ onSelect }) => {
  useEffect(() => {
    const channelType = payMobx.methodChannelMap.applePay
    if (channelType === 'StripeApplePay') {
      stripeConfigG.init()
    }
    return () => {
      stripeConfigG.remove()
    }
  }, [payMobx.methodChannelMap])
  if (!(window as any).ApplePaySession) {
    return null
  }
  return (
    <li className='group'>
      <div className='group-title' onClick={() => onSelect('applePay')}>
        <img src={require('@img/payment/apple-pay.png')} />
        {i18n.t('pay.applePay')}
      </div>
    </li>
  )
}

export default observer(MenuItem)
